module.exports = __webpack_public_path__ + "img/matsushita.ac1c8472.png";